module.exports = __webpack_public_path__ + "static/media/TS-asset5.a1d2bcf0.svg";